import React, { Component } from 'react';

class Titulo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let titulo = this.props.entidad.DescripcionPlural != undefined ? this.props.entidad.DescripcionPlural : this.props.entidad.Descripcion

        return (
            <div className="row">
                <div className="col-md-12">
                <h1>{titulo} {this.props.soloLectura ? <span className={"VistaInstanciaParametro-Titulo-SoloLectura"}>(Solo lectura)</span> : null}</h1>
                </div>
            </div>                  
        );
    }
};

export default Titulo